import Vue from 'vue'

let thisApp = null
const setApp = (app) => {
  thisApp = app
}

const installTimezone = {
  install: (app) => {
    // 兼容CountryList Cookie 之前存储不规范， 通过单独函数获取
    app.prototype.$getCookieCountryList = function() {
      if (thisApp.$cookies.get('countryList')) {
        if (typeof (thisApp.$cookies.get('countryList')) === 'string') {
          const newCountryList = thisApp.$cookies.get('countryList').replace(/\\\"/g, '"')
          return JSON.parse(newCountryList)
        } else {
          const newCountryList = thisApp.$cookies.get('countryList')
          return JSON.parse(JSON.stringify(newCountryList).replace(/\\\"/g, '"'))
        }
      } else {
        return []
      }
    }
    app.prototype.$SetCookieFn = (key, value, options) => {
      let opts = options
      if (!opts) {
        // 默认 Cookie 存储时间为一周
        opts = {
          maxAge: 60 * 60 * 24 * 7,
          path: '/'
        }
      } else if (!opts.maxAge) {
        opts.maxAge = 60 * 60 * 24 * 7
      } else if (!opts.path) {
        opts.path = '/'
      }
      thisApp.$cookies.set(key, value, opts)
    }
    app.prototype.$ClearAllCookieFn = (options) => {
      // if (!options) {
      //   thisApp.$cookies.removeAll({
      //     path: '/'
      //   })
      //   thisApp.$cookies.removeAll({
      //     path: '/seller-center'
      //   })
      // } else {
      //   thisApp.$cookies.removeAll(options)
      // }
      // 获取当前域名的所有 cookie
      const cookies = document.cookie.split(';')

      // 遍历所有 cookie 并将它们的过期时间设置为过去的时间
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i]
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
      }
    }
    app.prototype.$RemoveCookie = (key) => {
      const expireOptions = { path: '/', expires: new Date(0) }
      thisApp.$cookies.set(key, '', expireOptions) // 设置根路径的 Cookie 过期

      const currentPath = window.location.pathname
      const paths = ['/']
      let pathAccumulator = ''

      currentPath.split('/').forEach(part => {
        if (part) { // 忽略空的部分（避免生成多余的 /）
          pathAccumulator += `/${part}`
          paths.push(pathAccumulator)
        }
      })
      paths.push('/')
      paths.forEach(path => {
        thisApp.$cookies.set(key, '', { path, expires: new Date(0) })
      })
    }
  }
}
Vue.use(installTimezone)

export default ({ app }) => {
  setApp(app)
}
